import { SpreadBackgroundAction, SpreadBackgroundActionKeys } from '../actions/spreadBackground';
import { UiAction, UiActionKeys } from '../actions/ui';
import { EditableSliderData } from '../actions/editableItems';

export interface SpreadBackgroundState {
	isActive: boolean;
	isEdited: boolean;
	pagesData: { [key: number]: EditableSliderData };
}

const spreadBackgroundInitialState: SpreadBackgroundState = {
	isActive: false,
	isEdited: false,
	pagesData: {},
};

export const spreadBackground = (state: SpreadBackgroundState = spreadBackgroundInitialState, action: SpreadBackgroundAction | UiAction): SpreadBackgroundState => {
	switch (action.type) {
		case SpreadBackgroundActionKeys.SET_IS_SPREAD_BACKGROUND_ACTIVE:
			return {
				...state,
				isActive: action.isActive,
				isEdited: action.isActive ? state.isEdited : false,
			};
		case SpreadBackgroundActionKeys.SET_SPREAD_BACKGROUND:
			return {
				...state,
				isEdited: action.shouldSetIsEdited,
				pagesData: action.data
					? state.pagesData
					: {
						...state.pagesData,
						[action.spread[0]]: {},
					},
			};
		case SpreadBackgroundActionKeys.UPDATE_SPREAD_BACKGROUND_SERVICE_DATA: {
			return {
				...state,
				pagesData: {
					...state.pagesData,
					[action.page]: {
						...state.pagesData[action.page],
						...action.data,
					},
				},
			};
		}
		case UiActionKeys.RESET:
			return spreadBackgroundInitialState;
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/reducer/spreadBackground.ts